export const environment = {   
   apiUrl: 'https://x408xi6fhi.execute-api.us-east-1.amazonaws.com/development',  
   nodeEnv: 'prod',
   production: 'true',
   amplify: {
    Auth: {      
      region: 'us-east-1',
      userPoolId: 'us-east-1_SasRZxCBH',
      userPoolWebClientId: '68epck3hcn9bmgfd5d5qs4pdeh'
    }
  }
};
